import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useFieldActions } from '../../stores/form/useFieldActions.js';
import { useSplitSubvariantStore } from '../../stores/settings/useSplitSubvariantStore.js';
import { NavigationTab, NavigationTabs } from '../Tabs/NavigationTabs.js';
export const SplitNavigationTabs = () => {
    const { t } = useTranslation();
    const [state, setState] = useSplitSubvariantStore((state) => [
        state.state,
        state.setState,
    ]);
    const { setFieldValue } = useFieldActions();
    const handleChange = (_, value) => {
        setFieldValue('fromAmount', '');
        setFieldValue('fromToken', '');
        setFieldValue('toToken', '');
        setState(value === 0 ? 'swap' : 'bridge');
    };
    return (_jsxs(NavigationTabs, { value: state === 'swap' ? 0 : 1, onChange: handleChange, "aria-label": "tabs", children: [_jsx(NavigationTab, { label: t('header.swap'), disableRipple: true }), _jsx(NavigationTab, { label: t('header.bridge'), disableRipple: true })] }));
};
//# sourceMappingURL=SplitNavigationTabs.js.map